import * as React from "react";

export const TextArea = ({ label, placeholder, minHeight, name, onChange, value }) => {

    const inputId = label.toLowerCase().replace(/\s+/g, '-');
    
    return (
        <div className="flex flex-col mt-5 w-full text-sm min-h-[65px]">
            <label htmlFor={inputId} className="gap-1 self-stretch text-sm w-full text-gray-900 font-semibold">
                {label}
            </label>
            <textarea
                placeholder={placeholder}
                className="flex-1 gap-2.5 p-4 mt-1 bg-white rounded-md border border-solid border-navBtn text-slate-400 outline-primary text-base"
                style={{ minHeight }}
                aria-label={label}
                name={name}
                onChange={onChange}
                value={value}
            />
        </div>
    );
};